import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-lob-popup',
  templateUrl: './lob-popup.component.html',
  styleUrls: ['./lob-popup.component.css']
})
export class LobPopupComponent implements OnInit {

  openCont = true;
  openMenu = true;

  constructor(public dialogRef: MatDialogRef<LobPopupComponent>, public global: GlobalService) { }

  ngOnInit() {
  }

  gotoProductExplore(name) {
    this.closeLob()
    if (name == "Medical") {
      this.global.GotoPage("/listing/receipt-medical")

    } else {
      this.global.GotoPage("/listing/Receipting")
    }
  }
  closeLob(): void {
    this.dialogRef.close();
    // this.openMenu = false;
    // this.openCont = false;
    // setTimeout(() => {
    //   this.dialogRef.close();
    // }, 500)

  }

}
